import {Observable} from "rxjs/Observable"

import {
    FEED_KNOWLEDGE_ITEM_REQUEST,
    FEED_KNOWLEDGE_ITEM_RESPONSE,
    FEED_KNOWLEDGE_LIST_RESPONSE,
    FEED_KNOWLEDGE_LIST_SEARCH_REQUEST,
    FEED_KNOWLEDGE_LIST_PAGE_REQUEST,
    FEED_APPLY_FILTER_CRITERIA,
    FEED_APPLY_MODEL_UPDATE,
    FEED_CANCEL_MODEL_UPDATE,
    FEED_MODERATE,
} from "../actions/action-types"
import {
    moderationListRequest,
    moderationItemRequest,
    moderationItemFulltextRequest,
    moderationItemSaveRequest,
} from "../actions/moderation-feed-actions"
import {
    feedKnowledgeItemRequest,
    feedKnowledgeItemResponse,
    feedKnowledgeItemFulltextResponse,
    feedKnowledgeListPageRequest,
} from "../actions/feed-actions"
import {defaultSearchCriteria} from "../reducers/paging/feed-paging-reducer"
import {
    requestListFilterEpic,
    requestListSearchEpic,
    requestTopItemFromListResponseEpic,
    syncIdToURLEpic,
} from "./default-epics/default-entity-epics"

export const requestFeedKnowledgeUpdateEpic = (action$, {getState}) =>
    action$.ofType(FEED_APPLY_MODEL_UPDATE).map(() => {
        const {
            activeId,
            updateModel,
            imageToUpload,
        } = getState().presentation.feed
        return moderationItemSaveRequest(
            activeId,
            updateModel.toJS(),
            imageToUpload,
            feedKnowledgeItemResponse,
        )
    })

export const cancelFeedKnowledgeUpdateEpic = (action$, {getState}) =>
    action$
        .ofType(FEED_CANCEL_MODEL_UPDATE)
        .map(() =>
            feedKnowledgeItemRequest(getState().presentation.feed.activeId),
        )

export const requestFeedKnowledgeModerateEpic = (action$, {getState}) =>
    action$.ofType(FEED_MODERATE).map(({moderation, rejection_reason}) => {
        const {
            activeId,
            updateModel,
            imageToUpload,
        } = getState().presentation.feed
        const moderatedUpdateModel = updateModel
            .set("approved", moderation)
            .set("rejection_reason", rejection_reason)
        return moderationItemSaveRequest(
            activeId,
            moderatedUpdateModel,
            imageToUpload,
            feedKnowledgeItemResponse,
        )
    })

export const requestFeedKnowledgeItemEpic = action$ =>
    action$
        .ofType(FEED_KNOWLEDGE_ITEM_REQUEST)
        .mergeMap(({id, isInvalidating}) =>
            Observable.of(
                moderationItemRequest(
                    id,
                    isInvalidating,
                    feedKnowledgeItemResponse,
                ),
                moderationItemFulltextRequest(
                    id,
                    isInvalidating,
                    feedKnowledgeItemFulltextResponse,
                ),
            ),
        )

export const requestFeedKnowledgeSearchEpic = requestListSearchEpic(
    FEED_KNOWLEDGE_LIST_SEARCH_REQUEST,
    feedKnowledgeListPageRequest,
    "feed",
    "moderationFeed",
)

export const requestFeedKnowledgePageEpic = action$ =>
    action$
        .ofType(FEED_KNOWLEDGE_LIST_PAGE_REQUEST)
        .map(({type, ...pagingRequest}) => moderationListRequest(pagingRequest))

export const requestFeedKnowledgeFilterSearchEpic = requestListFilterEpic(
    FEED_APPLY_FILTER_CRITERIA,
    feedKnowledgeListPageRequest,
    "feed",
    "moderationFeed",
)

export const responseFeedKnowledgeListEpic = requestTopItemFromListResponseEpic(
    FEED_KNOWLEDGE_LIST_RESPONSE,
    feedKnowledgeItemRequest,
    "feed",
    "moderationFeed",
    defaultSearchCriteria,
)

export const syncFeedIdToURLEpic = syncIdToURLEpic(
    "knowledge",
    FEED_KNOWLEDGE_ITEM_RESPONSE,
)
